import { loadStripe } from '@stripe/stripe-js';

// Load Stripe with publishable key from environment
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export const createPaymentIntent = async (planType, customerEmail, customerDetails) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const API = `${BACKEND_URL}/api`;
  
  try {
    const response = await fetch(`${API}/payments/create-intent`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        plan_type: planType,
        customer_email: customerEmail,
        customer_details: customerDetails
      })
    });

    if (!response.ok) {
      throw new Error('Failed to create payment intent');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Payment intent creation failed:', error);
    throw error;
  }
};

export const confirmPayment = async (paymentIntentId) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const API = `${BACKEND_URL}/api`;
  
  try {
    const response = await fetch(`${API}/payments/confirm`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        payment_intent_id: paymentIntentId
      })
    });

    if (!response.ok) {
      throw new Error('Failed to confirm payment');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Payment confirmation failed:', error);
    throw error;
  }
};

export const processStripePayment = async (clientSecret, cardElement, stripe, customerDetails) => {
  try {
    const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: {
          name: `${customerDetails.first_name} ${customerDetails.last_name}`,
          email: customerDetails.email,
          phone: customerDetails.phone
        }
      }
    });

    if (error) {
      console.error('Payment failed:', error);
      return { success: false, error: error.message };
    }

    if (paymentIntent.status === 'succeeded') {
      return { 
        success: true, 
        paymentIntent,
        message: 'Payment processed successfully!' 
      };
    }

    return { 
      success: false, 
      error: 'Payment was not completed successfully' 
    };

  } catch (error) {
    console.error('Stripe payment processing error:', error);
    return { 
      success: false, 
      error: 'An unexpected error occurred during payment processing' 
    };
  }
};

export default stripePromise;